<template>
  <div>
    <div v-if="!selectedUser" class="sub-form">
      <div class="ttl-job">Search Company</div>
      <div class="ttl-inp">
        <v-autocomplete
          outline
          solo
          clearable
          hide-no-data
          append-icon="search"
          label="search"
          :search-input.sync="query"
          :items="company_items"
          item-text="company_name"
          return-object
          @change="populateUsers"
        >
        </v-autocomplete>
      </div>
      <div style="padding-bottom: 4rem" v-if="company_users.length > 0">
        <div class="ttl-job">
          Select User
        </div>
        <div class="user-synops" v-for="user in company_users">
          <div class="ttl nm">{{ user.user_name }}</div>
          <div class="ttl em">{{ user.email }}</div>
          <div class="ttl em">{{ user.phone }}</div>
          <div class="row">
            <div class="col-8 no-padding" style="margin-top: 1.5rem">
              <span
                v-bind:class="[
                  { ag: user.role === 'agent' },
                  { ad: user.role === 'admin' }
                ]"
                class="rl"
                >{{ user.role }}</span
              >
            </div>
            <div class="col-4 no-padding" style="text-align: right">
              <button
                v-if="user.email_confirmed"
                @click="selectUser(user)"
                class="btn btn-next-outline"
              >
                Select
              </button>
              <button v-else class="btn btn-cancel">
                Email Not Confirmed Yet
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="" v-else>
      <div>
        <job-form
          v-bind:from="from"
          v-bind:user="user"
          v-on:admin-job-post="confirmJobPosting"
          v-on:change-user="changeUser"
        ></job-form>
      </div>
    </div>
    <div :key="confirmCheck" v-if="confirmPost">
      <confirmation
        v-on:on-click-cancel="confirmPost = false"
        v-on:on-click-ok="approveJob"
        v-bind="propsConfirm"
      ></confirmation>
    </div>
    <div>
      <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
        <div style="text-align: center; width: 100%">
          <span style="padding-right:1.0rem"
            ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
          >{{ snackMessage }}
        </div>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import {
  ADMIN_POST_A_JOB,
  AUTO_SUGGEST_COMPANY_COMPLIANCE
} from "../../../Api/admin_api";
import JobForm from "../../employer/post-a-job/post-a-job-form";
import Confirmation from "../../global-components/confirmation-pop-up";
export default {
  name: "post-a-job",
  components: {
    JobForm,
    Confirmation
  },
  data: function() {
    return {
      from: "admin",
      user: {},
      company: {},
      query: "",
      company_items: [],
      company_users: [],
      selectedUser: false,
      confirmPost: false,
      confirmCheck: 0,
      job: {},
      propsConfirm: {
        open: false
      },
      bgColor: "#454545",
      timeOut: 1000,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
      ripple: false
    };
  },
  methods: {
    getCompany(v) {
      const self = this;
      AUTO_SUGGEST_COMPANY_COMPLIANCE(v)
        .then(function(data) {
          self.company_items = data;
        })
        .catch(function(data) {});
    },
    populateUsers(e) {
      const self = this;
      if (e) {
        self.company_users = e.users.sort((a, b) => (a.role > b.role ? 1 : -1));
      } else {
        self.company_users = [];
      }
    },
    resetAll() {
      const self = this;
      self.company_items = [];
      self.company_users = [];
      self.user = {};
      self.selectedUser = false;
    },
    selectUser(user) {
      const self = this;
      self.user = user;
      self.selectedUser = true;
    },
    confirmJobPosting(job, user) {
      const self = this;
      self.job = job;
      self.confirmCheck++;
      self.confirmPost = true;
      self.propsConfirm = {
        open: true,
        title: "Confirmation",
        message:
          "Posting job for " +
          self.user.user_name +
          " (" +
          self.user.role +
          ")." +
          " Approve now?"
      };
    },
    changeUser() {
      const self = this;
      self.selectedUser = false;
    },
    approveJob() {
      const self = this;
      self.job.action = "approve";
      self.job.user_id = self.user.user_id;
      self.confirmPost = false;
      ADMIN_POST_A_JOB(self.job)
        .then(function(response) {
          self.resetAll();
          if (response.status === 200) {
            self.snackbar = true;
            self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
            self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
            self.snackMessage = response.message;
          }
        })
        .catch(function(err) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = err.message;
        });
    }
  },
  watch: {
    query(val) {
      if (val === null) {
        this.resetAll();
      }
      val && this.getCompany(val);
    }
  }
};
</script>

<style scoped>
.sub-form {
  max-width: 80rem;
  margin: auto;
}
.ttl-job {
  text-align: left;
  font-size: 1.6rem;
  color: #050505;
}
.ttl-inp {
  text-align: left;
  padding: 0.5rem 0;
}
.user-synops {
  background-color: #ffffff;
  text-align: left;
  padding: 2rem;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.16);
  margin: 1rem 0;
}
.user-selected {
  text-align: left;
  max-width: 80rem;
  padding: 2rem;
  border: 1px solid #e6e6e6;
}
.ttl {
  font-size: 1.6rem;
}
.nm {
  font-size: 2rem;
  font-weight: bold;
  color: #050505;
}
.em {
  color: #3d4249;
}
.rl {
  font-size: 1.4rem;
  background-color: #0766ff;
  color: #ffffff;
  padding: 0 1rem;
  border-radius: 0.4rem;
}
.ag {
  background-color: #ff6e38;
}
.ad {
  background-color: var(--success);
}
</style>
